export default "__VITE_ASSET__DkfieQ0h__"